import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'activate:reader': () => import('./components/activate'),
        'page:article:content:after': () => import('./components/like'),
        'page:article:after': () => import('./components/comment'),
    }
});
